import { observer } from 'mobx-react-lite'
import {combinedMindboxCartEnabled} from '../../store/combinedMindboxCart'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Context } from '../../index'
import RecommendItem from './Recommend/RecommendItem'
import './basket.css'

import { Helmet } from 'react-helmet'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Navigation } from 'swiper'
import BreadCrumbsUI from '../../components/Breadcrumbs/BreadCrumbsUI/BreadCrumbsUI'
import AddressStep from '../../components/CheckoutSteps/AddressStep'
import Modal from '../../components/Modal/Modal'
import RecipientForm from '../../components/RecipientForm/RecipientForm'
import CitySelectionModal from '../../components/SelectCity/SelectCity'
import Accordion from '../../components/UI/Accordion/Accordion'
import ArrowLeft from '../../components/UI/Arrows/ArrowLeft'
import ArrowRight from '../../components/UI/Arrows/ArrowRight'
import ButtonUI from '../../components/UI/ButtonUI/ButtonUI'
import TrashBasket from '../../components/UI/trashBasket/TrashBasket'
import YM from '../../components/YM'
import MiniHeader from '../../components/header/MiniHeader'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { useModal } from '../../hooks/useModal'
import {
	getCourierDeliveryCost,
	getDeliveries,
	helpFindCity,
	mindboxGetRecommend,
	mindboxSetCart,
	priceToUserString,
	sdekGetCityOffice,
	yandexGetCityOffice,
} from '../../http/basketApi'
import { fetchCitysForOrderModal } from '../../http/settingsApi'
import {getPickupType} from '../../utils/format'
import { pushGoogleAnalyticProductAction } from '../../utils/googleAnalytic'
import EmptyBasket from './EmptyBasket/EmptyBasket'
import MainBlock, {UnavailableBasketItem} from './MainBlock/MainBlock'
import ModalRemove from './ModalRemove/ModalRemove'
import PaymentMethods from './PaymentMethods/PaymentMethods'
import TotalBasket from './TotalBasket/TotalBasket'
import './basket.scss'
import ModalPanel from "../../components/UI/ModalPanel/ModalPanel";
import PickupDetail from "../../components/Shipping/PickupDetail";
import { ReactComponent as AlertIcon } from "../../assets/icons/alert.svg";
import ReactDOMServer from "react-dom/server";
import {formatDeliveryDate} from "../../utils/date";
import DeliveryTypes from "../../components/CheckoutSteps/DeliveryTypes";
import PreorderCart, {CartSections, preorderCartEnabled} from './PreorderCart/PreorderCart';

const loadScript = (src, onLoad) => {

	if (window.ymaps) {
    if (onLoad) onLoad();
    return;
  }

	const script = document.createElement('script')
	script.src = src
	script.async = true
	document.body.appendChild(script)
	script.onload = onLoad
}

const legacyAnalyticsRows = raw => {
	try {
		const rows = typeof raw === 'string' ? JSON.parse(raw) : raw;
		return Array.isArray(rows) && rows.length <= 500 ? rows.filter(row => row && row.item && typeof row.item === 'object' && !Array.isArray(row.item)) : [];
	} catch {return []}
}

var centerValue = [55.76, 37.64]
var placemarkArray = []
// Установка точек(смена цветов)
var activePlacemark

const init = () => {
	const myMap = new window.ymaps.Map(
		'map',
		{
			// Координаты центра карты.
			// Порядок по умолчанию: «широта, долгота».
			// Чтобы не определять координаты центра карты вручную,
			// воспользуйтесь инструментом Определение координат.
			center: centerValue,
			// Уровень масштабирования. Допустимые значения:
			// от 0 (весь мир) до 19.
			zoom: 12,
		},
		{
			searchControlProvider: 'yandex#search',
		},
	)
	placemarkArray.forEach((item, index) => {
		var myPlacemark = new window.ymaps.Placemark(
			[item.latitude, item.longitude],
			{
				// Хинт показывается при наведении мышкой на иконку метки.
				hintContent: 'Содержимое всплывающей подсказки',
				// Балун откроется при клике по метке.
				balloonContent:
					'Адрес: ' +
					item.address_full +
					'</br> </br> режим работы: ' +
					item.work_time +
					'</br> </br>' +
					item.note +
					'',
			},
			{
				iconLayout: 'default#image',
				iconImageSize: [40, 52],
				iconImageHref: process.env.REACT_APP_API_URL + 'uploads/images/ywdeliverypoint.png',
				iconImageOffset: [-3, -42],
				code: item.code,
			},
		)
		myPlacemark.events.add('click', function (e) {
			var eMap = e.get('target')
			var code = eMap.options._options.code
			if (code) {
				let element = document.getElementById(code)

				if (element) {
					element.click()
					element.scrollIntoView({ block: 'start', behavior: 'smooth' })

					if (activePlacemark) {
						activePlacemark.options.set(
							'iconImageHref',
							process.env.REACT_APP_API_URL + 'uploads/images/ywdeliverypoint.png',
						)
					}
					activePlacemark = e.get('target')
					activePlacemark.options.set(
						'iconImageHref',
						process.env.REACT_APP_API_URL + 'uploads/images/ywwhiteprint.png',
					)
				}
			}
		})
		myMap.geoObjects.add(myPlacemark)
	})
	return myMap
}

// После того как метка была создана, добавляем её на карту.
const Basket = observer(() => {
	const basketPullItems = (basketStorage) => {
		return analyticsRows(basketStorage).map(function (basketItem) {
					return {
						id: basketItem.item.id,
						size: basketItem.currentSize,
						colorId: basketItem.colorId || basketItem.item.colorId || basketItem.item.color?.id,
						count: basketItem.count,
						pricePerItem: basketItem.item.parrent_price,
					}
			  })
	}



	const [modalActive, setModalActive] = useState(false)
	const { settings, user, basket, delivery } = useContext(Context)
	const cartLocation = useLocation()
	const splitCart = preorderCartEnabled() && Boolean(basket.preorderCart)
	const preorderSection = splitCart && basket.cartSection === 'preorder'
	const initializedCartSection = useRef(false)
	useEffect(() => {
		if (!splitCart || !basket.ordinaryOwnerReady) return;
		if (new URLSearchParams(cartLocation.search).get('view') === 'preorder') {
			basket.setCartSection('preorder'); initializedCartSection.current = true;
		}
	}, [basket, splitCart, basket.ordinaryOwnerReady, cartLocation.search])
	useEffect(() => {
		if (!splitCart || !basket.ordinaryOwnerReady || initializedCartSection.current) return;
		if (basket.preorderCart.lines.length || basket.activeBasketItems.length) {
			if (!basket.activeBasketItems.length && basket.preorderCart.lines.length) basket.setCartSection('preorder');
			initializedCartSection.current = true;
		}
	}, [basket, splitCart, basket.ordinaryOwnerReady, basket.preorderCart?.lines.length, basket.activeBasketItems.length])
	useEffect(() => {
		if (!splitCart || process.env.REACT_APP_AUTOMATIC_PREORDER_SITE_CHECKOUT_ENABLED !== 'true' ||
        !basket.ordinaryOwnerReady || !['enforced', 'legacy'].includes(basket.snapshotMode) || basket.snapshotLocked) return;
		const refresh = () => {if (!document.hidden) void basket.reconcilePreorderStock();};
		refresh();
		window.addEventListener('focus', refresh);
		document.addEventListener('visibilitychange', refresh);
		const timer = window.setInterval(refresh, 60000);
		return () => {window.clearInterval(timer); window.removeEventListener('focus', refresh);
			document.removeEventListener('visibilitychange', refresh);};
	}, [basket, splitCart, basket.sessionEpoch, basket.snapshotMode, basket.snapshotLocked, basket.ordinaryOwnerReady])
	const analyticsRows = raw => basket.snapshotMode === 'enforced' ?
		(basket.snapshotLocked ? [] : basket.basketItems.filter(row => row.status === 'visible' && row.item)) : legacyAnalyticsRows(raw);
	const [isValidRecipient, setIsValidRecipient] = useState(false)

	const addressStepRef = useRef(null)
	const recipientRef = useRef(null)
	const paymentsRef = useRef(null)

	const [isAddressOpen, setIsAddressOpen] = useState(false);
	const [shippingMethodTab, setShippingMethodTab] = useState('list')
	const [activePageInformation, setActivePageInformation] = useState(null)
	const [deviceUUID, setDeviceUUID] = useState('')
	const [userAgent, setUserAgent] = useState('')
	const [basketStorage, setBasketStorage] = useState(window.localStorage.getItem('basketStorage') || [])
	const [isChecked, setIsChecked] = useState(false)
	const [recommend, setRecommend] = useState(false)
	const [viewed, setViewed] = useState(false)
	const isTablet = useMediaQuery('(max-width: 768px)')
	const { isModalOpen: modalStepOne, openModal: openModalStepOne, closeModal: closeModalStepOne } = useModal()
	const { isModalOpen: modalStepOneDotFive, openModal: openModalStepOneDotFive, closeModal: closeModalStepOneDotFive } = useModal()

	const { isModalOpen: modalStepTwo, openModal: openModalStepTwo, closeModal: closeModalStepTwo } = useModal()

	const { isModalOpen: modalStepThree, openModal: openModalStepThree, closeModal: closeModalStepThree } = useModal()

	const {
		isModalOpen: isDetailModalOpen,
		openModal: openDetailModal,
		closeModal: closeDetailModal,
	} = useModal();

	const closeAllModals = () => {
		closeModalStepOne()
		closeModalStepOneDotFive()
		closeModalStepTwo()
		closeModalStepThree()
	}

	const handleOpenModalAuth = () => {
		user.setOpenAuthModal(1)
		user.setShadowOverlay(true)
		user.setStepModals('registration')
	}

	const MOBILE_MODAL_ACTIVE = useMemo(() => {
		return modalStepOne || modalStepTwo || modalStepThree
	}, [modalStepOne, modalStepTwo, modalStepThree])

	useEffect(() => {
		setDeviceUUID(document.cookie.replace(/(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/, '$1'))
		setUserAgent(window.navigator.userAgent)
	}, [])

	useEffect(() => {
		mindboxGetRecommend(deviceUUID, userAgent).then((response) => {
			if (response.items) {
				setRecommend(response.items)
			}
		})
	}, [])

	useEffect(() => {
		setBasketStorage(window.localStorage.getItem('basketStorage'))
	}, [])

	useEffect(() => {
		if (!combinedMindboxCartEnabled() && deviceUUID && userAgent) {
			mindboxSetCart(deviceUUID, userAgent, basketPullItems(basketStorage))
		}
	}, [basketStorage])

	const SELECTED_DELIVERY_DATA = useMemo(() => {
		if (delivery.officePvz) {
			return {
				address: delivery.officePvz.addressFields?.street || delivery.officePvz.address || delivery.officePvz.street,
				type: 'pickup',
				deliveryTerm: delivery.officePvz.deliveryTerm,
				typeName: getPickupType(delivery.officePvz.pickupType),
			}
		}

		if (delivery.selectedAddress) {
			return {
				address: delivery.selectedAddress.addressFields?.all?.value,
				type: 'courier',
				typeName: getPickupType(delivery.selectedAddress?.type),
				isFitting: delivery.fitting,
				isExpress: delivery.express
			}
		}

		return null
	}, [delivery.officePvz, delivery.selectedAddress, delivery.fitting, delivery.express])

	const SELECTED_PAYMENT = useMemo(() => {
		if(basket.selectPaymentType){
			return basket.selectPaymentType
		}
		return null
	}, [basket.selectPaymentType])


	useEffect(() => {
		window.scrollTo(0, 0)
		let reduceInform = basket.information.filter((item) => basket.startBasketNum === item.num)[0]
		setActivePageInformation(reduceInform)

		fetchCitysForOrderModal().then((response) => {
			if (response.error) {

				return false
			}
			setCityForOrder(response)
		})

		basket.setStartBasketNum(1)
		delivery.setActive(null)
		basket.setDeliveryPrice(0)

		YM(45473325, 'reachGoal', 260925825)
	}, [])

	useEffect(() => {
		window.scrollTo(0, 0)
		const filterResult = basket.information.filter((item) => item.num === basket.startBasketNum)
		if (filterResult[0]) {
			setActivePageInformation(filterResult[0])
		}
	}, [basket.startBasketNum])


	useEffect(() => {
		if (!basket.activeBasketItems.length) return

		if (basket.startBasketNum !== window.startBasketNum) window.startBasketNum = basket.startBasketNum
		else return

		const googleAnalyticBasketItems = basket.activeBasketItems.map((basketItem) => ({
			...basketItem.item,
			currentSize: basketItem.currentSize,
			customProps: { quantity: basketItem.count },
		}))
		let action = ''

		if (basket.startBasketNum === 1) action = 'view_cart'

		if (basket.startBasketNum === 2) action = 'begin_checkout'

		if (action) pushGoogleAnalyticProductAction(action, googleAnalyticBasketItems)

		if (isChecked) {
			selectAll(true)
		}
	}, [basket.startBasketNum, basket.basketItems])

	useEffect(() => {
		if (basket.startBasketNum === 1) {
			selectAll(true)
		}
	}, [basket.startBasketNum])

	useEffect(() => {
		if (basket.selectedItems.length === basket.activeBasketItems.length) {
			setIsChecked(true)
		} else {
			setIsChecked(false)
		}
	}, [basket.selectedItems])

	useEffect(() => () => (window.startBasketNum = -1), [])


	const deleteAuthItemController = (item) => {
		basket.removeItem(item)
	}

	const selectAll = (state) => {
		basket.selectAll(state)
	}

	const deliveriesRequest = useRef(0)
	const findDelivery = async (address) => {
		const request = ++deliveriesRequest.current
		if (!address) return;

		const response = await getDeliveries(address, preorderSection ? false : basket.hasGiftOnly)
		if (request !== deliveriesRequest.current) return
		if (!response || response.error) {
			delivery.setAllMethods(null)
			user.setShadowOverlay(false)
			return
		}

		user.setShadowOverlay(false)
		delivery.setAllMethods(response)
		delivery.setActive(null)

		/*if(selectedAddress){
			if (selectedAddress.type == 'pickup') {
				delivery.setOfficePvz(selectedAddress)
				const deliveryMethod = delivery.allMethods.pickup.find(
					(method) => method.delivery_type === (selectedAddress.pickupType == 'cdek'? 'sdek_pvz':'yandex_pvz')
				);
				delivery.setActive(deliveryMethod);
				delivery.setSelectedAddress(null);
			}
			if (selectedAddress.type == 'courier') {
				const costResult = await getCourierDeliveryCost(selectedAddress.addressFields.all, basket.priceNoSell);
				if (costResult.error) {
					delivery.setPrice(0);
					delivery.setActive(null);
					delivery.setError(costResult.error);
					delivery.setHasError(true);
				}

				const selectedDelivery = delivery.allMethods.courier.find((del) => del.delivery_type === costResult.type || del.target === costResult.type);

				if (selectedDelivery) {
					delivery.setPrice(costResult.cost);
					delivery.setActive(selectedDelivery);
					delivery.setError('');
					delivery.setHasError(false);
				}
				delivery.setOfficePvz(null)
				delivery.setSelectedAddress(selectedAddress.addressFields)
			}
		}*/
	}

	useEffect(() => {
		findDelivery(delivery.cityInfo)
	}, [delivery.cityInfo, basket.hasGiftOnly, preorderSection])

	const [cityForOrder, setCityForOrder] = useState(null)
	const [selectedAddress, setSelectedAddress] = useState(null)

	const setSityHandler = (item, saved = false) => {
		if (!item.data) {
			item = { value: item.name, data: item }
		}
		delivery.setCityInfo(item)
		delivery.setCityInfoError('')
		delivery.setPrice(0)
		delivery.setActive(null)
		delivery.setExpress(false)
		delivery.setFitting(false)
		//delivery.clearCustomerInfo()


		if(!saved){
			delivery.setSelectedAddress('')
			delivery.setOfficePvz(null)
			setSelectedAddress(null)
		}

		placemarkArray = []
		setOfficeList([])
	}

	//Выбор города - 1

	const callChangeCityModal = (number) => {
		user.setShadowOverlay(true)
		basket.setFunctionalModalState(number)
	}

	const closeFucntionalModal = () => {
		basket.setFunctionalModalState(null)
		user.setShadowOverlay(false)
	}

	useEffect(() => {
		if (user.shadowOverlay !== true) {
			basket.setFunctionalModalState(null)
		}
	}, [user.shadowOverlay])

	const [searchCityValue, setSearchCityValue] = useState(null)
	const [dadataFindResponse, setDadataFindResponse] = useState(null)

	const getOfferId = (item) => {
		let sizeId = 0
		for (var i in item.item.child_product_size) {
			let size = item.item.child_product_size[i]
			if (size.size_name == item.currentSize) {
				sizeId = size.id
				break
			}
		}

		return item.item.id.toString() + item.item.color.id.toString() + sizeId.toString()
	}

	useEffect(() => {
		helpFindCity(searchCityValue).then((response) => {
			const data = JSON.parse(response)
			if (data.suggestions.length) {
				setDadataFindResponse(data.suggestions)
				return false
			}
			setDadataFindResponse(null)
		})
	}, [searchCityValue])
	// END DELIVERY STEP

	const [officeList, setOfficeList] = useState(null)

	const selectAddress = (item) => {
		delivery.setSelectedAddress(item)
		if(item) {
			helpFindCity(item.city).then((response) => {
				const data = JSON.parse(response)
				if (data.suggestions.length) {
					setSityHandler(data.suggestions[0], true)
				}
			})
		}
	}

	const basketGoOneStep = async () => {
		const context = basket.snapshotMode === 'enforced' ? basket._sessionOperationContext() : null;
		const result = await basket.upStepPage(basket.startBasketNum)
		if (context && !basket._sessionOperationCurrent(context)) return false;
		if (!result) {
			window.scrollTo(0, 0)
			return false
		}

		if (result.order) {
			Navigate('/order/id/' + result.order.custom_order_id)
		}
	}

	useEffect(() => {
		if (delivery.officePvz) {
			if (delivery.active?.delivery_type === 'sdek_pvz') {
				sdekGetCityOffice(delivery.cityInfo).then((response) => {
					if (response.error) {
						return false
					}

					if (response.office) {
						setOfficeList(response.office)
						delivery.setPrice(response.deliveryPrice.delivery_sum)
						delivery.setTerms({
							calendar_min: response.deliveryPrice.calendar_min,
							calendar_max: response.deliveryPrice.calendar_max,
						})
						placemarkArray = []
						response.office.forEach((item, index) => {
							placemarkArray.push({
								code: item.code,
								latitude: item.location.latitude,
								longitude: item.location.longitude,
								note: item.note ? 'Как добраться: ' + item.note : 'нет комментария',
								work_time: item.work_time,
								address_full: item.location.address_full,
							})
						})
						centerValue = [delivery.cityInfo.data.geo_lat, delivery.cityInfo.data.geo_lon]
						loadScript('https://api-maps.yandex.ru/2.1/?apikey=ac12f8b6-c9dc-447c-a20d-80c0689a51c0&lang=ru_RU', () => {
							window.ymaps.ready(init)
						})
					}
				})
			}

			/*if (delivery.active?.delivery_type === 'yandex_pvz') {
				yandexGetCityOffice(delivery.cityInfo).then((response) => {
					const { points } = response
					if (points?.length) {
						placemarkArray = points
						setOfficeList(points)
					}
					centerValue = [delivery.cityInfo.data.geo_lat, delivery.cityInfo.data.geo_lon]

					loadScript('https://api-maps.yandex.ru/2.1/?apikey=ac12f8b6-c9dc-447c-a20d-80c0689a51c0&lang=ru_RU', () => {
						window.ymaps.ready(init)
					})
				})
			}*/
		}
	}, [delivery.officePvz, basket.functionalModalState])

	const selectDeliverySdekHandler = () => {
		user.setShadowOverlay(false)
	}

	const ucFirst = (str) => {
		if (!str) return str
		return str[0].toUpperCase() + str.slice(1).toLowerCase()
	}

	const deleteSelected = () => {
		let items = basket.basketItems.filter((item) => item.selected)
		if (items.length == basket.basketItems.length) {
			basket.removeAllItems('active', false)
		} else {
			items.forEach((item) => {
				basket.removeItem(item)
			})
		}
	}

	const handleDeleteBasket = () => {
		setModalActive((p) => !p)
	}

	const SERTIFICATE_PAYMENT = useMemo(() => {
		if(basket.certificates.length > 1){
			return basket.certificateTotal > 0
		}
		return false
	},[basket.certificateTotal, basket.certificates.length])

	const DELIVERY_VALID = useMemo(() => {
		console.log(delivery.selectedAddress)
		return !!delivery.officePvz || !!delivery.selectedAddress
	}, [delivery.officePvz, delivery.selectedAddress])

	const USER_DATA_VALID = useMemo(() => {

		return (
			delivery.customerInfo.telephone &&
			delivery.customerInfo.name &&
			delivery.customerInfo.surname &&
			delivery.customerInfo.email &&
			delivery.customerInfo.agreePrivacy
		)
	}, [delivery.customerInfo])

	const IS_AVAILABLE_ORDER = useMemo(() => {
		return DELIVERY_VALID && USER_DATA_VALID && (SELECTED_PAYMENT || SERTIFICATE_PAYMENT) &&
			(basket.snapshotMode !== 'enforced' || basket.ordinaryCheckoutCanAdvance)

	}, [DELIVERY_VALID, USER_DATA_VALID, SELECTED_PAYMENT, SERTIFICATE_PAYMENT, basket.snapshotMode, basket.ordinaryCheckoutCanAdvance])

	const PAYMENT_BUTTON_TEXT = useMemo(() => {

		switch(SELECTED_PAYMENT?.code) {
			case "payment_online":
				return "Оплатить"
			case "dolyami":
				return "Оплатить <img src=\"/files/images/payments/icon/dolyami.svg\">"
			case "ysplit":
				return "Оплатить <img src=\"/files/images/payments/icon/split.svg\">"
			case "sbp":
				return "Оплатить <img src=\"/files/images/payments/icon/spb.svg\">"
			default:
				return "Оформить заказ"
		}

	}, [SELECTED_PAYMENT])

	const getComponentInnerText = function(
		component
	) {
		const retVal = ReactDOMServer.renderToStaticMarkup(component);
		const div = document.createElement("div");
		div.innerHTML = retVal;
		return div.textContent || div.innerText || "";
	}

	const navigate = useNavigate()

	const handleGoBack = () => {

		basket.clearPromoNotificator()

		if(basket.startBasketNum > 1){
			basket.downStepPage(basket.startBasketNum)
		} else {
			navigate(-1)
		}
	}

	const handleClose = () => {
		navigate(-1)
	}

    const disabledInMainView = basket.snapshotMode === 'enforced' ? basket.disabledBasketItems.filter(item => item.status !== 'unavailable') : basket.disabledBasketItems;
    if(!viewed && (basket.snapshotMode === 'enforced' || basketStorage)){
        let items = analyticsRows(basketStorage).map(function (basketItem) {
            return basketItem.item.productId
        })
        items = items.filter((item) => {return item !== undefined}).map((item) => item.toString())
        if(items.length > 0){
            const sendView = () => {try {if (typeof window.turboTargetPixelRTGListBasket === 'function') window.turboTargetPixelRTGListBasket(items);} catch { /* Optional analytics cannot reject a basket render. */ }};
            if (window.turboTarget && window.turboTarget.sendRTGMessage) {
                sendView();
            } else {
                document.addEventListener("generalPixelInited", sendView)
            }
            setViewed(true)
        }
    }


	return (
		<div style={{ marginTop: settings.headerHeight }} className={'basket_page'}>
			<MiniHeader
				onClickArrowButton={MOBILE_MODAL_ACTIVE ? closeAllModals : handleGoBack}
				onClickCrossButton={handleClose}
			/>
			{modalActive ? <ModalRemove closeCallback={handleDeleteBasket} basket={basket} /> : null}
			<BreadCrumbsUI
				className={'basket_page__breadCrumbs'}
				items={[
					{ name: 'Главная', link: '/' },
					{ name: 'Корзина', link: '/personal/basket/' },
				]}
				separator='/'
			/>
			<Helmet>
				<title>Корзина интернет-магазина YOU WANNA</title>
				<meta
					name='description'
					content='Корзина в интернет-магазине YOU WANNA. По имеющимся вопросам звоните: ☎ +7 (926) 887-70-07'
				/>
			</Helmet>
			{splitCart && <CartSections basket={basket}/>}
			{splitCart && <div id="cart-panel-preorder" role="tabpanel" aria-labelledby="cart-tab-preorder" hidden={!preorderSection}>
				{preorderSection && <PreorderCart/>}
			</div>}
			<div id={splitCart ? 'cart-panel-ordinary' : undefined} role={splitCart ? 'tabpanel' : undefined}
				aria-labelledby={splitCart ? 'cart-tab-ordinary' : undefined} hidden={preorderSection}>
			<div
				className={
					basket.functionalModalState ? 'basket_special_fucntional_modal active' : 'basket_special_fucntional_modal'
				}
			>
				{settings.projectWidth && settings.projectWidth > 768 ? (
					<div className={'map_container_sdek'}>
						{basket.functionalModalState === 2 ? (
							<div className={'map_container_for_switch'}>
								<div id='map'></div>
							</div>
						) : (
							''
						)}
					</div>
				) : (
					''
				)}
				<div className={'container_to_switch_modal_state'}>
					<div className={'basket_functional_modal_for_close'}>
						{basket.functionalModalState === 2 ? (
							<div className={'modal_state_choose_pvz_heading'}>Выберите пункт выдачи</div>
						) : (
							''
						)}
						<div onClick={(e) => closeFucntionalModal()} className={'basket_order_fucntional_exit_div'}></div>
					</div>
					{basket.functionalModalState === 1 ? (
						<CitySelectionModal
							cityForOrder={cityForOrder}
							setSityHandler={setSityHandler}
							closeModal={closeFucntionalModal}
							isOpen={basket.functionalModalState === 1}
						/>
					) : (
						''
					)}
					{basket.functionalModalState === 2 ? (
						<div className={'modal_state_choose_pvz'}>
							<span className={'modal_satate_choose_pvz_city_info'}>
								{delivery.cityInfo ? delivery.cityInfo.value : ''}
							</span>
							<div className='modal_state_choose_pvz_tabs'>
								<button
									className={'modal_state_choose_pvz_tab' + (shippingMethodTab === 'list' ? ' active' : '')}
									onClick={() => setShippingMethodTab('list')}
								>
									Список
								</button>
								<button
									className={'modal_state_choose_pvz_tab' + (shippingMethodTab === 'map' ? ' active' : '')}
									onClick={() => setShippingMethodTab('map')}
								>
									Карта
								</button>
							</div>

							{officeList && (delivery.type === 'sdek_pvz' || delivery.type === 'yandex_pvz') ? (
								<div
									className={'choose_office_pvz_list'}
									style={{
										display:
											(settings.projectWidth && settings.projectWidth > 768) || shippingMethodTab === 'list'
												? 'block'
												: 'none',
									}}
								>
									{delivery.type === 'sdek_pvz'
										? officeList.map((item, index) => {
												return (
													<div
														onClick={(e) => delivery.setOfficePvz(item)}
														id={item.code}
														className={
															delivery.officePvz?.code === item.code
																? 'one_office_pvz_choose active'
																: 'one_office_pvz_choose'
														}
														key={index}
													>
														<div className={'one_office_pvz_active_check'}>
															<div className={'one_office_pvz_circle'}>
																<span className={'active_pvz_circle'}></span>
															</div>
														</div>
														<div className={'one_office_pvz_right_content'}>
															<span className={'one_office_pvz_small_heading'}>СДЭК</span>
															<div className={'one_office_pvz_address'}>{item.location?.address}</div>
															{delivery.terms ? (
																<div className={'one_office_pvz_support_price_wrapper'}>
																	<div className={'one_office_pvz_price'}>
																		Стоимость :{' '}
																		{!basket.delPrice ? 'бесплатно' : priceToUserString(basket.delPrice) + ' ₽'}
																	</div>
																	<div className={'one_office_pvz_price'}>
																		Срок доставки: от {delivery.terms.calendar_min} до {delivery.terms.calendar_max}{' '}
																		рабочих дней.
																	</div>
																</div>
															) : (
																''
															)}
															<div className={'one_office_pvz_work_time'}>
																<span className={'pvz_work_time_heading'}>Режим работы: </span>
																<div className={'one_office_time'}>{item.work_time}</div>
															</div>
														</div>
													</div>
												)
										  })
										: officeList.map((item, index) => {
												return (
													<div
														onClick={(e) => delivery.setOfficePvz(item)}
														id={item.code}
														className={
															delivery.officePvz?.code === item.code
																? 'one_office_pvz_choose active'
																: 'one_office_pvz_choose'
														}
														key={index}
													>
														<div className={'one_office_pvz_active_check'}>
															<div className={'one_office_pvz_circle'}>
																<span className={'active_pvz_circle'}></span>
															</div>
														</div>
														<div className={'one_office_pvz_right_content'}>
															<span className={'one_office_pvz_small_heading'}>Yandex</span>
															<div className={'one_office_pvz_address'}>{item.address_full}</div>
															{
																<div className={'one_office_pvz_work_time'}>
																	<span className={'pvz_work_time_heading'}>Режим работы: </span>
																	<div className={'one_office_time'}>{item.work_time}</div>
																</div>
															}
														</div>
													</div>
												)
										  })}
								</div>
							) : (
								''
							)}
							<div
								className={'map_container_sdek'}
								style={{
									display:
										settings.projectWidth && settings.projectWidth <= 768 && shippingMethodTab === 'map'
											? 'block'
											: 'none',
								}}
							>
								{basket.functionalModalState === 2 ? (
									<div className={'map_container_for_switch'}>
										<div id='map'></div>
									</div>
								) : (
									''
								)}
							</div>
							<div
								onClick={(e) => selectDeliverySdekHandler()}
								className={delivery.officePvz ? 'select_this_pvz' : 'select_this_pvz disactive'}
							>
								{' '}
								Привезти сюда{' '}
							</div>
						</div>
					) : (
						''
					)}
				</div>
			</div>
			{activePageInformation && basket.activeBasketItems.length > 0 ? (
				<div className={'container_basket_page'}>
					<div className={'content_basket_page_wrapper'}>
						{basket.startBasketNum === 1 ? (
							<div className={'basket_one_step'}>
								{basket.startBasketNum === 1 ? (
									<div className={'wrapper_container_limiter'}>
										<div className={'basket_and_order_column basket_wrapper_for_items'}>
											<MainBlock basket={basket} handleDeleteBasket={handleDeleteBasket} />
													{recommend.length > 0 ? (
												<div className={'basket_page_slider_block'}>
													<div className={'basket_page_slider_header'}>
														<span>Вам также может понравиться</span>
														{recommend.length > 3 ? (
															<div className={'basket_page_slider_buttons'}>
																<button className={'basket_page_slider_left'}>
																	<ArrowLeft />
																</button>
																<button className={'basket_page_slider_right'}>
																	<ArrowRight />
																</button>
															</div>
														) : (
															''
														)}
													</div>
													<Swiper
														modules={[Navigation]}
														navigation={{
															nextEl: '.basket_page_slider_left',
															prevEl: '.basket_page_slider_right',
														}}
														spaceBetween={0}
														slidesPerView={3}
														className={'basket_page_slider_body'}
													>
														{recommend.map((item, index) => {
															return (
																<SwiperSlide>
																	<RecommendItem item={item} index={index} key={item.id} />
																</SwiperSlide>
															)
														})}
													</Swiper>
												</div>
											) : (
												''
											)}
										</div>
										<div className="basket_page_right_column">
											<TotalBasket basket={basket} buttonText={"К оформлению"} />
										</div>
									</div>
								) : (
									''
								)}
							</div>
						) : (
							<div
								className={
									basket.startBasketNum === 4 ? 'wrapper_container_limiter finish_step' : 'wrapper_container_limiter'
								}
							>
								<div id={'BPW_wrapper'} className={'basket_wrapper_for_items'}>
									<h1 className='basket-title'>Оформление заказа</h1>
									{!user.isAuth && (
										<div className='basket-auth'>
											<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M11.25 11.25L11.291 11.23C11.4192 11.1659 11.5631 11.14 11.7057 11.1552C11.8482 11.1703 11.9834 11.2261 12.0952 11.3157C12.2071 11.4054 12.2909 11.5252 12.3368 11.661C12.3826 11.7968 12.3886 11.9429 12.354 12.082L11.646 14.918C11.6111 15.0572 11.6169 15.2034 11.6627 15.3394C11.7084 15.4754 11.7922 15.5954 11.9041 15.6852C12.016 15.775 12.1513 15.8308 12.294 15.846C12.4367 15.8612 12.5807 15.8352 12.709 15.771L12.75 15.75M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12ZM12 8.25H12.008V8.258H12V8.25Z'
													stroke='black'
													strokeWidth='1.5'
													strokeLinecap='round'
													strokeLinejoin='round'
												/>
											</svg>

											<div className='basket-text'>
												<button type='button' onClick={handleOpenModalAuth}>
													Авторизуйтесь
												</button>
												, чтобы увидеть персональные условия доставки
											</div>
										</div>
									)}
									<div className='basket-step-item'>
										<Accordion
											ref={addressStepRef}
											trigger={'Адрес и способ доставки'}
											content={
												<AddressStep
													onSelectAddress={(item) => {
														selectAddress(item)
														if(item !== false) {
															addressStepRef.current.close()

															setTimeout(() => {
																recipientRef.current.open()
															}, 0)
														}
													}}
													onPvzInfoClick={() => {openDetailModal()}}
												/>
											}
											duration={300}
											defaultOpen={!SELECTED_DELIVERY_DATA}
											disabled={isTablet}
											onClick={isTablet ? openModalStepOne : null}
											onToggle={setIsAddressOpen}
											//blocked={!!SELECTED_DELIVERY_DATA}
										/>

										{(SELECTED_DELIVERY_DATA && !isAddressOpen) || (isTablet && SELECTED_DELIVERY_DATA) ? (
											<>
												<div className='basket-step-item__control'>
													<div className="basket-step-item__selected">
														<div className="basket-selected-address-name" onClick={SELECTED_DELIVERY_DATA?.type === 'pickup' ? openDetailModal : null}>
															{
																SELECTED_DELIVERY_DATA?.isExpress ?
																	<div className="basket-selected-address-express">
																		<svg className="delivery-types__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
																		</svg> Экспресс-доставка
																	</div> : SELECTED_DELIVERY_DATA?.typeName

															}

															{
																SELECTED_DELIVERY_DATA?.type === 'pickup' &&
																<AlertIcon />
															}
														</div>
														<div className="basket-selected-address-street">
															{SELECTED_DELIVERY_DATA?.address}
														</div>
														<div className="basket-selected-address-delivery">
															{SELECTED_DELIVERY_DATA?.deliveryTerm ? formatDeliveryDate(SELECTED_DELIVERY_DATA.deliveryTerm) : ''}
														</div>
														{
															SELECTED_DELIVERY_DATA?.isFitting &&
															<div className="basket-selected-address-express">
																<svg className="delivery-types__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path fillRule="evenodd" clipRule="evenodd" d="M10.0556 4.05546C10.5714 3.53973 11.2708 3.25 12.0002 3.25C12.7295 3.25 13.429 3.53973 13.9447 4.05546C14.4605 4.57118 14.7502 5.27065 14.7502 6C14.7502 6.41421 14.4144 6.75 14.0002 6.75C13.586 6.75 13.2502 6.41421 13.2502 6C13.2502 5.66848 13.1185 5.35054 12.8841 5.11612C12.6497 4.8817 12.3317 4.75 12.0002 4.75C11.6687 4.75 11.3507 4.8817 11.1163 5.11612C10.8819 5.35054 10.7502 5.66848 10.7502 6C10.7502 7.4223 11.3023 8.5295 12.4325 9.38666L20.3273 13.7723C20.7562 14.0105 21.1136 14.3592 21.3624 14.782C21.6112 15.2048 21.7423 15.6864 21.7422 16.177V17C21.7422 17.7293 21.4525 18.4288 20.9367 18.9445C20.421 19.4603 19.7215 19.75 18.9922 19.75H4.99219C4.26284 19.75 3.56337 19.4603 3.04764 18.9445C2.53192 18.4288 2.24219 17.7293 2.24219 17L2.24219 16.1772C2.24209 15.6866 2.37322 15.2048 2.62197 14.782C2.87076 14.3591 3.22814 14.0105 3.65706 13.7723L10.7146 9.85178C9.74611 8.81112 9.25019 7.5164 9.25019 6C9.25019 5.27065 9.53992 4.57118 10.0556 4.05546ZM11.9922 10.858L4.3854 15.0836C4.19044 15.1919 4.0279 15.3504 3.91482 15.5426C3.80173 15.7348 3.74213 15.9538 3.74219 16.1768V17C3.74219 17.3315 3.87388 17.6495 4.1083 17.8839C4.34272 18.1183 4.66067 18.25 4.99219 18.25H18.9922C19.3237 18.25 19.6416 18.1183 19.8761 17.8839C20.1105 17.6495 20.2422 17.3315 20.2422 17V16.177C20.2422 15.954 20.1826 15.7348 20.0696 15.5426C19.9565 15.3504 19.794 15.1919 19.5991 15.0837L11.9922 10.858Z" fill="#1B1B1B"/>
																</svg> С примеркой
															</div>
														}
													</div>
													{
														!isTablet && <ButtonUI
															className='basket-step-item__control-button'
															text='Изменить'
															type='button'
															theme='outline'
															onClick={() => {
																delivery.setOfficePvz(null)
																delivery.setActive(null)
																delivery.setSelectedAddress(null)
																addressStepRef.current.open()
															}}
														></ButtonUI>
													}
												</div>
											</>
										) : (
											<span className='basket-step-item__suggestion'>Выбрать способ доставки</span>
										)}
									</div>

									{isDetailModalOpen && (
										<Modal
											modalClassName="selected-detail-modal"
											onClose={closeDetailModal}
										>
											<ModalPanel
												className="selected-detail"
												onClose={closeDetailModal}
												withoutOffset
											>
												<PickupDetail
													data={delivery.officePvz}
													hasButton={false}
													onClose={closeDetailModal}
												/>
											</ModalPanel>
										</Modal>
									)}

									{modalStepOne && (
										<Modal modalClassName='step-modal-overlay' onClose={closeModalStepOne}>
											<div className='step-modal'>
												<div className='step-modal__top'>
													<MiniHeader onClickArrowButton={MOBILE_MODAL_ACTIVE ? closeAllModals : undefined} />
												</div>

												<div className='step-modal__body'>
													<h3 className='step-modal__title'>Адрес и способ доставки</h3>
													<AddressStep
														onPvzInfoClick={() => {openDetailModal()}}
														onSelectAddress={(item) => {
															selectAddress(item)
															if(item !== false) {
																closeModalStepOne()
																openModalStepOneDotFive()
															}
														}}
														onPvzSelect={(() => {
															openModalStepOneDotFive()
														})}
													/>
												</div>

												<ButtonUI text='Сохранить и продолжить' onClick={closeModalStepOne} />
											</div>
										</Modal>
									)}

									{modalStepOneDotFive && (
										<Modal modalClassName='step-modal-overlay' onClose={closeModalStepOneDotFive}>
											<div className='step-modal'>
												<div className='step-modal__top'>
													<MiniHeader onClickArrowButton={() => {
														closeModalStepOneDotFive()
														openModalStepOne()
													}}/>
												</div>

												<div className='step-modal__body'>
													<h3 className='step-modal__title'>Адрес и способ доставки</h3>
													<div className="basket-selected-address">
														<div className="basket-selected-address-type">
															{SELECTED_DELIVERY_DATA?.type === 'courier' && <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M7.25002 14.25C7.25002 14.6478 7.09198 15.0293 6.81068 15.3107C6.52937 15.592 6.14784 15.75 5.75002 15.75C5.35219 15.75 4.97066 15.592 4.68936 15.3107C4.40805 15.0293 4.25002 14.6478 4.25002 14.25M7.25002 14.25C7.25002 13.8522 7.09198 13.4706 6.81068 13.1893C6.52937 12.908 6.14784 12.75 5.75002 12.75C5.35219 12.75 4.97066 12.908 4.68936 13.1893C4.40805 13.4706 4.25002 13.8522 4.25002 14.25M7.25002 14.25H13.25M4.25002 14.25H2.37502C2.07665 14.25 1.7905 14.1315 1.57952 13.9205C1.36855 13.7095 1.25002 13.4234 1.25002 13.125V9.74999M13.25 14.25H15.5M13.25 14.25V9.74999M1.25002 9.74999V2.11499C1.24843 1.84116 1.34848 1.57648 1.53081 1.37217C1.71313 1.16786 1.96477 1.03845 2.23702 1.00899C5.57006 0.663019 8.92997 0.663019 12.263 1.00899C12.828 1.06699 13.25 1.54699 13.25 2.11499V3.07299M1.25002 9.74999H13.25M18.5 14.25C18.5 14.6478 18.342 15.0293 18.0607 15.3107C17.7794 15.592 17.3978 15.75 17 15.75C16.6022 15.75 16.2207 15.592 15.9394 15.3107C15.6581 15.0293 15.5 14.6478 15.5 14.25M18.5 14.25C18.5 13.8522 18.342 13.4706 18.0607 13.1893C17.7794 12.908 17.3978 12.75 17 12.75C16.6022 12.75 16.2207 12.908 15.9394 13.1893C15.6581 13.4706 15.5 13.8522 15.5 14.25M18.5 14.25H19.625C20.246 14.25 20.754 13.746 20.715 13.126C20.5141 9.82363 19.4019 6.64155 17.502 3.93299C17.3211 3.67927 17.0848 3.47001 16.8111 3.32102C16.5373 3.17203 16.2333 3.08722 15.922 3.07299H13.25M13.25 3.07299V9.74999" stroke="#1B1B1B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
															</svg>}
															{SELECTED_DELIVERY_DATA?.type === 'courier' && <span>Курьер</span>}
															{SELECTED_DELIVERY_DATA?.type === 'pickup' &&
																<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M1.0994 17H11.3836H15.5379H18.8983M17.6151 17V6.64356M17.6151 6.64356C17.0612 6.9512 16.4139 7.06493 15.783 6.96545C15.152 6.86598 14.5762 6.55942 14.1531 6.09778C13.6454 6.65067 12.9032 7 12.076 7C11.683 7.00036 11.2944 6.92 10.9362 6.76426C10.578 6.60852 10.2584 6.381 9.99884 6.09689C9.49109 6.65067 8.74886 7 7.92169 7C7.52867 7.00036 7.14009 6.92 6.7819 6.76426C6.42371 6.60852 6.10414 6.381 5.84454 6.09689C5.42165 6.55868 4.84588 6.8654 4.21489 6.96504C3.5839 7.06468 2.93655 6.9511 2.38262 6.64356M17.6151 6.64356C17.983 6.43903 18.2972 6.15572 18.5333 5.81557C18.7693 5.47541 18.9209 5.08752 18.9763 4.68191C19.0318 4.27631 18.9895 3.86386 18.8529 3.47649C18.7162 3.08912 18.4889 2.73721 18.1884 2.448L17.0898 1.39111C16.8303 1.14099 16.4783 1.00031 16.1112 1H3.88555C3.51855 1.00008 3.16658 1.14043 2.90698 1.39022L1.80932 2.448C1.50951 2.73754 1.28276 3.08952 1.14655 3.47678C1.01033 3.86404 0.968304 4.27624 1.0237 4.68161C1.07909 5.08699 1.23042 5.4747 1.46603 5.81486C1.70164 6.15501 2.01522 6.43853 2.38262 6.64356M2.38262 17V6.64356" stroke="#1B1B1B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
																</svg>
															}
															{SELECTED_DELIVERY_DATA?.type === 'pickup' && <span>Самовывоз, ПВЗ</span>}
														</div>
														<div className="basket-selected-address-name" onClick={SELECTED_DELIVERY_DATA?.type === 'pickup' ? openDetailModal : null}>
															{SELECTED_DELIVERY_DATA?.typeName}
															{
																SELECTED_DELIVERY_DATA?.type === 'pickup' &&
																<AlertIcon />
															}
														</div>
														<div className="basket-selected-address-street">
															{SELECTED_DELIVERY_DATA?.address}
														</div>
														<div className="basket-selected-address-delivery">
															{SELECTED_DELIVERY_DATA?.deliveryTerm ? formatDeliveryDate(SELECTED_DELIVERY_DATA?.deliveryTerm) : ''}
														</div>
													</div>
													<TotalBasket basket={basket} showOrderButton={false} showPromoAndBonus={false} />
												</div>

												<ButtonUI text='Продолжить' onClick={closeAllModals} />
											</div>
										</Modal>
									)}

									<div className='basket-step-item'>
										<Accordion
											ref={recipientRef}
											trigger={'Получатель'}
											content={<RecipientForm />}
											className={!DELIVERY_VALID? '_inactive': ''}
											duration={300}
											disabled={isTablet || !DELIVERY_VALID}
											onClick={isTablet ? openModalStepTwo : null}
										/>
										{(isTablet || !recipientRef.current?.isOpen()) && !USER_DATA_VALID && (
											<span className='basket-step-item__suggestion'>Указать контактные данные</span>
										)}
										{
											isTablet &&	USER_DATA_VALID && <div className='basket-step-item__selected'>
												<span>{delivery.customerInfo.surname} {delivery.customerInfo.name}</span>
												<span>{delivery.customerInfo.telephone}</span>
												<span>{delivery.customerInfo.email}</span>
											</div>
										}
									</div>
									{modalStepTwo && (
										<Modal modalClassName='step-modal-overlay' onClose={closeModalStepTwo}>
											<div className='step-modal'>
												<div className='step-modal__top'>
													<MiniHeader onClickArrowButton={MOBILE_MODAL_ACTIVE ? closeAllModals : undefined} />
												</div>

												<div className='step-modal__body'>
													<h3 className='step-modal__title'>Получатель</h3>
													<RecipientForm closeModalStepTwo = {closeModalStepTwo} setIsValid={(val) => setIsValidRecipient(val)} />
												</div>

												<ButtonUI text='Продолжить' onClick={closeModalStepTwo} disabled={!USER_DATA_VALID} />
											</div>
										</Modal>
									)}

									<div className='basket-step-item'>
										<Accordion
											ref={paymentsRef}
											trigger={'Оплата'}
											content={<PaymentMethods />}
											className={!USER_DATA_VALID || !DELIVERY_VALID || SERTIFICATE_PAYMENT? '_inactive': ''}
											duration={300}
											disabled={isTablet || !USER_DATA_VALID || !DELIVERY_VALID }
											onClick={isTablet ? openModalStepThree : null}
										/>
										{(isTablet || !paymentsRef.current?.isOpen()) && !SELECTED_PAYMENT && (
											<span className='basket-step-item__suggestion'>Выбрать способ оплаты</span>
										)}
										{isTablet && SELECTED_PAYMENT && <div className='basket-step-item__selected'>{SELECTED_PAYMENT.name}</div>}
									</div>

									{modalStepThree && (
										<Modal modalClassName='step-modal-overlay' onClose={closeModalStepThree}>
											<div className='step-modal'>
												<div className='step-modal__top'>
													<MiniHeader onClickArrowButton={MOBILE_MODAL_ACTIVE ? closeAllModals : undefined} />
												</div>

												<div className='step-modal__body'>
													<h3 className='step-modal__title'>Способы оплаты</h3>
													<PaymentMethods />
												</div>

												<ButtonUI text='Продолжить' onClick={closeModalStepThree} />
											</div>
										</Modal>
									)}
								</div>
								<div className={'basket_page_right_column'}>
									<TotalBasket basket={basket}  buttonText={PAYMENT_BUTTON_TEXT} disabledButton={!IS_AVAILABLE_ORDER}/>
								</div>
							</div>
						)}

						{disabledInMainView && disabledInMainView.length > 0 && basket.startBasketNum === 1 ? (
							<div className={'basket_one_step_disabled'}>
								<div className={'wrapper_container_limiter'}>
									<div className={'basket_count_items_and_clear_line basket_wrapper_for_items'}>
										<span className={'basket_page_counter disabled_red'}>Нет в наличии</span>
										<span onClick={(e) => basket.removeAllItems('disable')} className={'basket_page_clear_basket'}>
											Очистить всё
										</span>
									</div>

									<div className={'basket_page_for_product_list'}>
										{disabledInMainView[0]
											? disabledInMainView.map((item, index) => {
													return (
														<div
															id={getOfferId(item)}
															key={index}
															className={'basket_page_one_disabled_item_container'}
														>
															<div className={'basket_page_disable_content_container'}>
																<div className={'basket_page_image_preview'}>
																	<img
																		src={
																			process.env.REACT_APP_API_URL +
																			'uploads/images/' +
																			item.item.product.id +
																			'/' +
																			item.item.id +
																			'/' +
																			'214_' +
																			item.item.img_preview
																		}
																		alt={'YouWanna - ' + (item.item.name ? item.item.name : '')}
																	/>
																</div>

																<div className={'basket_page_container_price_and_basket'}>
																	<div className={'basket_page_one_item_content_section'}>
																		<div className={'basket_page_disable_text_container'}>
																			<div className={'basket_page_content_text_information_disabled'}>
																				<div className={'product_name_articul_color'}>
																					<div className={'basket_page_disabled_name_container'}>
																						{ucFirst(item.item.name)}
																					</div>
																					<div className={'basket_page_articul_container'}>
																						<span>Артикул: {' ' + item.item.product.articul}</span>
																					</div>
																					{settings.projectWidth && settings.projectWidth < 381 ? (
																						<div className={'basket_page_color_container'}>
																							<div className={'basket_page_disabled_info_container'}>
																								<span>Товар закончился</span>
																							</div>
																							<div className={'delate_wrapper'}>
																								<div
																									onClick={(e) => deleteAuthItemController(item, user.user.id)}
																									className={'basket_page_trash_container'}
																								>
																									<TrashBasket />
																								</div>
																							</div>
																						</div>
																					) : (
																						<div className={'basket_page_disabled_info_container'}>
																							<span>Товар закончился</span>
																						</div>
																					)}
																				</div>
																			</div>
																			{settings.projectWidth && settings.projectWidth > 380 ? (
																				<div className={'delate_wrapper'}>
																					<div
																						onClick={(e) => deleteAuthItemController(item, user.user.id)}
																						className={'basket_page_trash_container'}
																					>
																						<TrashBasket />
																					</div>
																				</div>
																			) : (
																				''
																			)}
																		</div>
																	</div>
																</div>
															</div>

														</div>
													)
											  })
											: ''}
									</div>
								</div>
							</div>
						) : (
							''
						)}
					</div>
				</div>
			) : (
				<div>
					<EmptyBasket />
					{basket.disabledBasketItems && basket.disabledBasketItems.length > 0 ? (
						<div className={'content_basket_page_wrapper'}>
							<div className={'basket_one_step_disabled'}>
								<div className={'wrapper_container_limiter'}>
									<div className={'basket_count_items_and_clear_line basket_wrapper_for_items'}>
										<span className={'basket_page_counter disabled_red'}>Нет в наличии</span>
										<span onClick={(e) => basket.removeAllItems('disable')} className={'basket_page_clear_basket'}>
											Очистить всё
										</span>
									</div>
									<div className={'basket_page_for_product_list'}>
										{basket.disabledBasketItems[0]
											? basket.disabledBasketItems.map((item, index) => {
													if (basket.snapshotMode === 'enforced' && item.status === 'unavailable') return <UnavailableBasketItem key={item.lineKey} basket={basket} item={item}/>;
													return (
														<div
															id={getOfferId(item)}
															key={index}
															className={'basket_page_one_disabled_item_container'}
														>
															<div className={'basket_page_disable_content_container'}>
																<div className={'basket_page_image_preview'}>
																	<img
																		src={
																			process.env.REACT_APP_API_URL +
																			'uploads/images/' +
																			item.item.product.id +
																			'/' +
																			item.item.id +
																			'/' +
																			'214_' +
																			item.item.img_preview
																		}
																		alt={'YouWanna - ' + (item.item.name ? item.item.name : '')}
																	/>
																</div>

																<div className={'basket_page_container_price_and_basket'}>
																	<div className={'basket_page_one_item_content_section'}>
																		<div className={'basket_page_disable_text_container'}>
																			<div className={'basket_page_content_text_information_disabled'}>
																				<div className={'product_name_articul_color'}>
																					<div className={'basket_page_disabled_name_container'}>
																						{ucFirst(item.item.name)}
																					</div>
																					<div className={'basket_page_articul_container'}>
																						<span>Артикул: {' ' + item.item.product.articul}</span>
																					</div>
																					{settings.projectWidth && settings.projectWidth < 381 ? (
																						<div className={'basket_page_color_container'}>
																							<div className={'basket_page_disabled_info_container'}>
																								<span>Товар закончился</span>
																							</div>
																							<div className={'delate_wrapper'}>
																								<div
																									onClick={(e) => deleteAuthItemController(item, user.user.id)}
																									className={'basket_page_trash_container'}
																								>
																									<TrashBasket />
																								</div>
																							</div>
																						</div>
																					) : (
																						<div className={'basket_page_disabled_info_container'}>
																							<span>Товар закончился</span>
																						</div>
																					)}
																				</div>

																			</div>
																			{settings.projectWidth && settings.projectWidth > 380 ? (
																				<div className={'delate_wrapper'}>
																					<div
																						onClick={(e) => deleteAuthItemController(item, user.user.id)}
																						className={'basket_page_trash_container'}
																					>
																						<TrashBasket />
																					</div>
																				</div>
																			) : (
																				''
																			)}
																		</div>
																	</div>
																</div>
															</div>


														</div>
													)
											  })
											: ''}
									</div>
								</div>
							</div>
						</div>
					) : (
						''
					)}
				</div>
			)}
			</div>
		</div>
	)
})

export default Basket
